export const workerIsNotEligibleForMissionErrorValues = [
  'shiftUnavailable',
  'workerUnavailable',
  'hoursQuotaExceeded',
  'institutionOrServiceDeactivatedByWorker',
  'workerOrServiceOrJobsOrSpecialtiesNotAccepted',
] as const

export type WorkerIsNotEligibleForMissionError =
  (typeof workerIsNotEligibleForMissionErrorValues)[number]
